import { CSSProperties, useCallback, useRef, useState } from "react";
import { Button, Col, Divider, Form, Input, notification, Space, Typography } from "antd";
import { ImFloppyDisk } from "react-icons/im";
import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

import { IEtapaSolicitacaoAtivacao, ISolicitacaoAtivacao } from "../../../interfaces";

import SolicitacoesDeAtivacaoService from "../../../../../../services/http/services/SaldoDeContas/SolicitacoesDeAtivacaoService";
import { EmitirErro } from "../../../../../../services/EmitirErro";
import { stateGlobal } from "../../../../../../interfaces/Global";

interface IProps {
    solicitacaoId: number;
    etapa: IEtapaSolicitacaoAtivacao | undefined;
    onUpdateObservacao: (solicitacao: ISolicitacaoAtivacao) => void;
    style?: CSSProperties;
}

const IconFloppyDisk = (props: any) => { return <Icon {...props} component={ImFloppyDisk} ></Icon> }

export default function InputObservacaoEtapa({
    etapa,
    solicitacaoId,
    onUpdateObservacao,
    style,
}: IProps) {
    const [isSubmiting, setIsSubmiting] = useState(false);

    const formRef = useRef<any>(null);
    const propsState = useSelector((state: stateGlobal) => state.global);

    const handleSubmit = useCallback((): void => {
        formRef.current?.validateFields()
            .then(async (values: any) => {
                if (!etapa || !solicitacaoId) {
                    return;
                }

                try {
                    setIsSubmiting(true);

                    const data = await SolicitacoesDeAtivacaoService.updateObservacaoEtapa({
                        etapaId: etapa.id,
                        observacao: values.observacao,
                        solicitacaoId,
                    });

                    notification.success({
                        message: 'Sucesso',
                        description:
                            'Observação atualizada com sucesso!',
                    });

                    setIsSubmiting(false);
                    onUpdateObservacao(data);
                } catch (error) {
                    setIsSubmiting(false);
                    EmitirErro(error, true, 'updateObservacaoEtapa_023klshjd7asks9dk29');
                }
            })
            .catch(() => {
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });
    }, []);

    return (
        <Col
            span={24}
            style={{
                padding: '0 10px',
                ...style
            }}
        >
            <div
                style={{
                    border: `1px solid ${propsState.theme === 'light' ? '#0000000f' : '#ffffff1f'}`,
                    borderRadius: 8,
                    padding: '12px 0',
                }}
            >
                <div
                    style={{
                        padding: '0 16px',
                    }}
                >
                    <Typography.Title level={5} style={{ margin: 0 }}>Observação da etapa</Typography.Title>
                </div>

                <Divider style={{ margin: '12px 0' }} />

                <div
                    style={{
                        padding: '4px 16px',
                    }}
                >
                    <Form
                        ref={formRef}
                        name="formObervacaoEtapa"
                        layout="vertical"
                        initialValues={{
                            remember: true,
                            observacao: etapa?.observacao,
                        }}
                    >
                        <Form.Item
                            name="observacao"
                            initialValue={etapa?.observacao}
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                            style={{
                                marginBottom: 0,
                            }}
                        >
                            <Space.Compact style={{ width: '100%' }}>
                                <Input.TextArea
                                    defaultValue={etapa?.observacao || ''}
                                    placeholder="Digite uma observação para a etapa"
                                    style={{
                                        borderRadius: '8px 0 0 8px'
                                    }}
                                />

                                <Button
                                    type="primary"
                                    onClick={handleSubmit}
                                    disabled={isSubmiting}
                                    loading={isSubmiting}
                                    className="botaoVincularUsuarioInAtendimentos"
                                    title="Salvar"
                                    style={{
                                        height: 'auto',
                                        maxHeight: 200,
                                        borderRadius: '0 8px 8px 0'
                                    }}
                                >
                                    <IconFloppyDisk />
                                </Button>
                            </Space.Compact>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </Col>
    )
}
